import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ResponsiveGrid from './ResponsiveGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, ResponsiveGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/grid/demos/responsive/ResponsiveGrid.tsx",
    "fileName": "ResponsiveGrid.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Paper from '@mui/material/Paper';\nimport Grid from '@mui/material/Grid';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(2),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function ResponsiveGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>\n        {Array.from(Array(6)).map((_, index) => (\n          <Grid key={index} size={{ xs: 2, sm: 4, md: 4 }}>\n            <Item>{index + 1}</Item>\n          </Grid>\n        ))}\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Paper from '@mui/material/Paper';\nimport Grid from '@mui/material/Grid';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(2),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function ResponsiveGrid() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>\n        {Array.from(Array(6)).map((_, index) => (\n          <Grid key={index} size={{ xs: 2, sm: 4, md: 4 }}>\n            <Item>{index + 1}</Item>\n          </Grid>\n        ))}\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "container"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "md"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "3"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "columns"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "sm"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "md"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "12"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1",
                "Array"
              ],
              ".",
              [
                "span",
                "pl-en",
                "from"
              ],
              "(",
              [
                "span",
                "pl-c1",
                "Array"
              ],
              "(",
              [
                "span",
                "pl-c1 di-num",
                "6"
              ],
              ")).",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "_"
              ],
              ", ",
              [
                "span",
                "pl-v",
                "index"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "index"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "sm"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "md"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "            <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "index"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "+"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 29,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Paper",
      "@mui/material/Grid"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
